import { 
  SliceContentImage,
  SliceOrganisations,
  SliceBlockImage as CoreSliceBlockImage,
  createSliceLayout,
  SliceCuratorCardsGrid,
  SliceCuratorCardsGridProps,
  SliceBannerTout,
  PageKnowledgeHubLayoutProps,
  SliceBannerToutProps,
  SliceContentImageProps,
  SliceContactForm,
  SliceContactFormProps,
} from '@shapeable/ui';
// import { SliceBannerTout } from '../entities/slice-banner-tout';
import { SliceBlockThumbnailGrid } from '../entities/slice-block-thumbnail-grid';
import { SliceSectionContentBlock } from '../entities/slice-section-content-block';
import { LinkCard } from '../entities/link-card';
import { APP_CHROME } from '../../theme';
import { SliceKnowledgeHubLayout } from '../entities/slice-knowledge-hub-layout';


// Augment standard site layouts here by exporting additional or replacement layouts.
// (simply use the same key to replace any existing slice layouts).

export const SliceLayoutContentImageStretch = createSliceLayout(
  SliceSectionContentBlock, {
    verticalPadding: 'none',
    boundary: 'none',
    fadeColor: '#00000000',
    props: {
      
    },
  }
);

export const SliceLayoutBlockThumbnailGrid = createSliceLayout(
  SliceBlockThumbnailGrid, {
    verticalPadding: 'none',
    boundary: 'none',
  }
);

export const SliceBlockImage = createSliceLayout(
  CoreSliceBlockImage, {
    verticalPadding: 'none',
    boundary: 'none',
  }
);


export const SliceLayoutBannerTout = createSliceLayout<SliceBannerToutProps>(
    SliceBannerTout, {
      verticalPadding: 'medium',
      fadeColor: '#00000000',
      props: {
        animate: true,
      }
    }
);

export const SliceLayoutContentImageReverse = createSliceLayout<SliceContentImageProps>(
  SliceContentImage, {
    verticalPadding: 'small',
    props: {
      reverse: true,
      animate: true,
    } 
  }
);

export const SliceLayoutContentImage = createSliceLayout<SliceContentImageProps>(
  SliceContentImage, {
    verticalPadding: 'none',
    props: {
      imageWidth: 100,
      animate: true,
    }
  }
);

export const SliceLayoutOrganisations = createSliceLayout(
  SliceOrganisations, {
    verticalPadding: 'content',
    props: {
      hasHeader: false,
    }
  }
);

export const SliceLayoutKeyMessage = createSliceLayout(
  SliceOrganisations, {
    verticalPadding: 'content',
    props: {
      hasHeader: false,
    }
  }
);

export const SliceLayoutCuratorCardsGrid = createSliceLayout<SliceCuratorCardsGridProps>(
  SliceCuratorCardsGrid, {
    boundary: 'content',
    props: {
      card: LinkCard
    }
  }
);

export const SliceLayoutKnowledgeHub = createSliceLayout<PageKnowledgeHubLayoutProps>(
  SliceKnowledgeHubLayout, {
    boundary: 'content',
    verticalPadding: 'medium',
    props: {
      showAllTab: true,
      filterSize: 'slim',
      filterSpacing: 5,
      useContentTabs: true,
      contentTabsProps: { colors: { background: APP_CHROME, text: 'dark' } },
      entityTypes: { 
        Entity: {
          // label: 'Reads',
          // latestTitle: 'Latest Reads',
          sortBy: 'published',
          reverse: true,
          filterFieldNames: ['types'],
          spacing: 3,
          toggleTypes: [
            { name: 'Post', label: 'Posts' },
            { name: 'FeedEntry', label: 'Articles' },
          ],
        },
      },
    }
  }
);

export const SliceLayoutContactForm = createSliceLayout<SliceContactFormProps>(
  SliceContactForm, {
    props: {
      variant: 'inline',
      showMembershipCheckbox: false,
      showOrganisationType: false,
      showFamilyName: false,
      showJobTitle: false,

      givenNameLabel: "Name (Required):",
      emailLabel: "Email (Required):",
      messageLabel: "What can we do for you?"
    }
  }
);